<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                Добавить новый Навык
            </div>
            <div class="content-inner">
                <div class="header-for-input">Наименование Навыка</div>
                <input type="text" class="content-input input_width_50" v-model="type_of_work.name" />
                <!--- --- -->
                <div class="header-for-input">Вес в баллах </div>
                <input type="text" class="content-input input_width_50" v-model="type_of_work.value" />
                <!--- --- -->
                <div class="btn_main_button" @click="new_type_of_work()">Добавить</div>
            </div>
        </div>
    </div>
</template>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'NewTypeOfWork',
    props: ['id'],
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            type_of_work: {
                corpstandart_id: this.id,
                name: '',
                value: 0
            }
        }
    },
    methods: {
        new_type_of_work() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/corpstandart_type_of_works', this.type_of_work)
            .then(response => {
                this.operation_info = response.data.data
                this.isSuccess = true
                loader.hide();
                this.$router.go(-1)
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    }
}
</script>

<style scoped src="../../../assets/style/main.css"></style>
<style scoped src="../../../assets/style/account.css"></style>
<style scoped src="../../../assets/style/buttons.css"></style>